import React, {useEffect, useState} from 'react';
import Frame from "../common/Frame";
import {appdata} from "../../logic_tmp/appdata/AppData";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import './Price.css';
import {MotivationBlock} from "../common/MotivationBlock";
import {EventData} from "../common/EventData";
import {registerConcersion} from "../../logic/funel/FacebookUtils";
import {pingApi} from "../../backend/connectors/JavaConnector";
import {calculatePricesAndCounts} from "../../logic/setup/PriceCalculator";
import {PackagesBlock} from "./PackagesBlock";
import {calcResource, lgSetup} from "../../backend/LgSetup";
import {removeProfile} from "../../logic_tmp/storage/LgProfile";
import i18next from "i18next";
import {SpecialProposal} from "../common/SpecialProposal";
import {HallPlan} from "../common/HallPlan";
import SoldSectorButton from "./SoldSectorButton";



export function Sectors() {
    pingApi().then()
    window.gtag('event', 'conversion', {'send_to': 'AW-457108933/EG_ICLjbpMAYEMXb-9kB'});
    const [counter, setCounter] = useState(0);
    const [updated, setUpdated] = useState(false);

    const handlePricesUpdate = () => {
        setUpdated(!updated) // П
    };

    useEffect(() => {
        registerConcersion('AddToWishlist');
    }, []);
    const forceRender = () => {
        setCounter(counter + 1);
    };
    const {t} = useTranslation();
    const history = useHistory();
    const dropSpecialProposal = (e) => {
        e.preventDefault();
        specialProposal["status"] = "DEACTIVATED"
        forceRender()
    }
    pingApi().then(r => {
    })
    let specialProposal = appdata.product["specialProposal"]
    let specialProposalConfig
        if (appdata.spKeyRedim)
            specialProposalConfig = appdata.product["specialProposalConfig"][appdata.spKeyRedim]
    appdata.header = undefined
    function sectorSelected(sector) {
            appdata["sector"] = sector
        let newref = "/amt?productCode=" + sector + "&lng=" + i18next.language + "&spKeyRedim=" + appdata.spKeyRedim + "&utm_source=" + appdata.utm_source + "&utm_medium=" + appdata.utm_medium + "&utm_campaign=" + appdata.utm_campaign;
        if (appdata["priceNote"] !== undefined)
            newref = newref + "&priceNote=" + appdata["priceNote"];
            window.location.href =  newref
        }
    let placementKey = "FreePlacement"
    if (appdata.product["seatsType"] === "FIXED")
        placementKey = "HowToSelectSeats"
    if (appdata.product["seatsType"] === "ZONES")
        placementKey = "HowToSelectZones"
    if (appdata.product["seatsType"] === "ONLINE")
        placementKey = "HowToConnecToOnline"
    if (appdata.product["homepageUrl"] === "https://duoclassico.eu/michael2025-listz-1-en")
        placementKey = "CARNEGIEHALLPlacementKey"
    return (
        <div id="pricePage">
            <Frame>
                <EventData/>
                <h2 className="offer-pay__title bigfont">
                    {appdata.errorMessageKey !== undefined?
                        <div className="redfont">
                            {t(appdata.errorMessageKey)}
                        </div>:<div></div>
                    }
                    {appdata.spKeyRedim !== undefined?
                        <div className="redfont">
                            {t(specialProposalConfig["messageKey"])}
                       </div>:<div></div>}


                    <table>
                        <tbody>
                        {Object.keys(appdata.product["sectors"]).map(sector => {
                                let pr = lgSetup.products[sector]
                                let res1 = {}
                                res1.spKeyRedim = appdata.spKeyRedim
                                res1.currency = pr["currency"]
                                calculatePricesAndCounts(res1,pr)
                                let priceInfo = ""
                                if (res1.priceReduced > 0)
                                    priceInfo = res1.priceReduced + pr["currency"] + " - "
                                priceInfo = priceInfo + res1.priceFull + pr["currency"]
                                let sectorInfoKey = pr["sector"]["descriptionKey"]
                                let sectorInfo2 = ""
                                let sectorInfo = t(pr["sector"]["descriptionKey"])
                                let sectorInfoTr = t(sectorInfoKey)
                                if (pr["seatsType"] !== "FREE")
                                    sectorInfo2 = t("rows") + " " + pr["sector"]["startRow"] + "-" +  pr["sector"]["endRow"]

                            let sectorStatus = "ACTIVE"
                                if (pr["sector"]["sectorStatus"] !== undefined)
                                    sectorStatus = pr["sector"]["sectorStatus"]



                            return <tr key={sector}>

                                    <td className="col2-s">
                                        {(sectorInfo === "YouTube")?
                                            <div>
                                                <img
                                                    src='https://www.gstatic.com/youtube/img/branding/youtubelogo/svg/youtubelogo.svg'
                                                />
                                            </div>:
                                        <div>
                                            <div>
                                            {sectorInfoTr}
                                            </div>
                                            <div>
                                            {sectorInfo2}
                                            </div>
                                        </div>
                                        }
                                    </td>
                                    {(specialProposal === undefined || specialProposal["status"] !== "ACTIVE" || appdata.spKeyRedim !== undefined)?
                                    <td className="col2-b">
                                        {(sectorStatus === "ACTIVE")?
                                        <button id="nextButtonPrice"  onClick={()=>sectorSelected(sector)}
                                                className="select-btn">
                                            <span>{t("select")}</span>
                                        </button>:<div></div>
                                        }
                                        {(sectorStatus === "SOLD")?
                                            <SoldSectorButton/>
                                            :<div></div>
                                        }

                                    </td>
                                        :<div></div>}
                                    <td className="col2-l">
                                        {priceInfo}
                                    </td>
                                </tr>
                            }
                        )}
                        </tbody>
                    </table>
                </h2>
                {(appdata.discountTill !== undefined) ?
                    <h2 className="offer-pay__title red bigfont">
                        <div
                            className="offer-pay__title red bigfont">{t("ThisPricesAreValidTill", {date: appdata.discountTillMessage})}</div>
                    </h2> : <div></div>}
                <div>
                </div>
                <MotivationBlock></MotivationBlock>
                <SpecialProposal onPricesUpdate={handlePricesUpdate} ></SpecialProposal>
                {(specialProposal !== undefined && specialProposal["status"] === "ACTIVE" && appdata.spKeyRedim === undefined)?
                <div className="app-button d-flex justify-content-around">
                    <button id="nextButtonSpecial" onClick={(e) => dropSpecialProposal(e)}
                            className="g-btn app-btn-further next-step-btn y-btn">
                        <span> {t("continueWithNormalPrice")}</span>
                    </button>
                </div>
                    :<div></div>}
                <p className="app-text">
                    {t(placementKey)}
                </p>
                <PackagesBlock/>
            </Frame>
        </div>
    );
}
